import { createRoute, lazyRouteComponent, redirect, type AnyRootRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import { requireAuth, AuthRedirect } from '../../shared/guards/requireAuth'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'welcome', sv, true, true)
i18n.addResourceBundle('en', 'welcome', en, true, true)

async function guardSignedIn(href: string) {
  try {
    await requireAuth({ href })
  } catch (e) {
    if (e instanceof AuthRedirect) throw redirect({ to: e.to, search: e.search })
    throw e
  }
}

export function buildWelcomeRoutes<TRoot extends AnyRootRoute>(rootRoute: TRoot) {
  return [
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/welcome',
      beforeLoad: ({ location }) => guardSignedIn(location.href),
      component: lazyRouteComponent(() => import('./pages/WelcomePage'), 'WelcomePage'),
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/welcome/create-area',
      beforeLoad: ({ location }) => guardSignedIn(location.href),
      component: lazyRouteComponent(() => import('./pages/CreateAreaPage'), 'CreateAreaPage'),
    }),
    // The page the link-other-email mail points at. Lives with /welcome, where
    // the request starts. Signed-in only: the link is confirmed for the
    // identity that asked for it, so a signed-out visitor goes through /login
    // and comes back here with the token intact.
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/auth/link-account',
      beforeLoad: ({ location }) => guardSignedIn(location.href),
      component: lazyRouteComponent(() => import('./pages/LinkAccountPage'), 'LinkAccountPage'),
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/register',
      beforeLoad: () => {
        throw redirect({ to: '/welcome/create-area' })
      },
    }),
  ]
}
